/* raw layout hash: _anonymous-web-layout:663ac191572b4a356fd592a314a02dc91639d34b7497d422d31244b86c9998d7 */
import React from 'react';
import AnonymousShell from './AnonymousShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_anonymous-web-layout" — renders its page content through the router outlet.
export default function AnonymousWebLayout() {
  return <AnonymousShell layoutName="_anonymous-web-layout" menu={LAYOUT_MENUS['_anonymous-web-layout']} />;
}
